import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { setPageTitle } from "../lib/format";

export default function NotFound() {
  useEffect(() => setPageTitle("Page not found"), []);
  return (
    <div className="min-h-screen flex flex-col" data-testid="not-found-page">
      <Navbar />
      <main className="flex-1 flex flex-col items-center justify-center px-5 text-center pt-28 pb-24">
        <p className="font-display font-extrabold text-7xl text-[#E50914]" data-testid="not-found-code">404</p>
        <h1 className="mt-4 text-2xl font-bold">This spot is taken.</h1>
        <p className="mt-2 text-sm text-zinc-400 max-w-sm">The page you're looking for doesn't exist or has moved.</p>
        <div className="mt-8 flex gap-3">
          <Link to="/" data-testid="not-found-home" className="btn-primary text-sm"><Compass className="w-4 h-4" /> Back to MyRedPark</Link>
          <Link to="/find" data-testid="not-found-find" className="btn-secondary text-sm">Find Parking</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
